import { FC } from 'react'
import { Col } from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'

import PerText from '../Text'
import PerFlexRow from '../FlexRow'
import { useAmountAndCurrency } from '../../../shared/useAmountAndCurrency'

interface SettingsModalLocalePreviewProps {
  timezone: string
  locale: string
  currency: string
}

export const SettingsModalLocalePreview: FC<SettingsModalLocalePreviewProps> = ({ timezone, locale, currency }) => {
  const { t } = useTranslation()
  const { formatCurrency, formatDecimal } = useAmountAndCurrency(locale)

  const localMoment = moment().tz(timezone)
  localMoment.locale(locale)

  return (
    <>
      <PerFlexRow align="top">
        <Col span={4}>
          <PerText color="secondary">{t('settingsModal.preview')}</PerText>
        </Col>
        <Col span={20}>
          <PerFlexRow align="top">
            <Col span={8}>
              <PerText color="secondary" fontSize="s">
                {t('settingsModal.timeFormat')}
              </PerText>
            </Col>
            <Col span={16}>
              <PerText color="secondary" fontSize="s">
                {localMoment.format('LT')}
              </PerText>
            </Col>
          </PerFlexRow>
          <PerFlexRow align="top">
            <Col span={8}>
              <PerText color="secondary" fontSize="s">
                {t('settingsModal.dateFormat')}
              </PerText>
            </Col>
            <Col span={16}>
              <PerText color="secondary" fontSize="s">
                {localMoment.format('L')}
              </PerText>
            </Col>
          </PerFlexRow>
          <PerFlexRow align="top">
            <Col span={8}>
              <PerText color="secondary" fontSize="s">
                {t('settingsModal.decimalNotation')}
              </PerText>
            </Col>
            <Col span={16}>
              <PerText color="secondary" fontSize="s">
                {formatDecimal(10000.99)}
              </PerText>
            </Col>
          </PerFlexRow>
          <PerFlexRow align="top">
            <Col span={8}>
              <PerText color="secondary" fontSize="s">
                {t('settingsModal.currencyNotation')}
              </PerText>
            </Col>
            <Col span={16}>
              <PerText color="secondary" fontSize="s">
                {formatCurrency(10000.99, currency)}
              </PerText>
            </Col>
          </PerFlexRow>
        </Col>
      </PerFlexRow>
    </>
  )
}
